<template>
  <div class="module-container">
    <div class="module-header">
      <h3 class="module-title">设备管理</h3>
    </div>
    <div class="module-content">
      <div class="stats-header">
        <div class="stats-title">在管设备数量</div>
        <span class="more-link" @click="goToDeviceInfo">查看更多</span>
      </div>
      <div class="equipment-stats">
        <div class="stat-card">
          <div class="stat-section">
            <span class="section-label"><img src="../../../../static/image/six/shebei-wangluoshebei.png" alt=""
                class="status-icon">使用中设备</span>
            <span class="section-value large" style="color: #64FCFF;" :title="usingCount">{{ usingCount }}</span>
          </div>
          <div class="stat-section">
            <span class="section-label"><img src="../../../../static/image/six/shebei-wangluoshebei.png" alt=""
                class="status-icon">暂停使用设备</span>
            <span class="section-value large" style="color: #CBD6ED;" :title="pausedCount">{{ pausedCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEquipmentStatus } from '@/api/greenMan/index'

export default {
  name: 'EquipmentManagement',
  data() {
    return {
      usingCount: 0,
      pausedCount: 0,
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchEquipmentStatus()
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchEquipmentStatus, 1800000)
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    fetchEquipmentStatus() {
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.usingCount = 0
      this.pausedCount = 0
      const projectId = JSON.parse(window.localStorage.userInfo).projectId;
      getEquipmentStatus({ projectId }).then(res => {
        if (res) {
          this.usingCount = res.data.data.usingCount || 0
          this.pausedCount = res.data.data.pausedCount || 0
        }
      })
    },
    goToDeviceInfo() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))

      // 检查是否有设备信息维护权限
      if (userRoles && userRoles.includes('equ_jichutaizhangweihu')) {
        // 有权限，跳转到设备信息维护
        this.$router.push('/deviceStatisticalAnalysis/deviceFileMan/basicledgerMain');
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问设备信息维护'
        });
      }
    }
  }
}
</script>

<style scoped lang="scss"> 
.module-container {
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33px;
  margin: 10px 0;
  background-image: url(../../../../static/image/six/title-1.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
}

.module-title {
  font-family: Source Han Sans CN;
  font-weight: 800;
  font-size: 19px;
  color: #FFFFFF;
  line-height: 17px;
  margin-bottom: 40px;
}

.module-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stats-header {
  height: 33px;
  position: relative;
  background-image: url(../../../../static/image/six/title.png);
  background-repeat: no-repeat;
  background-position: left;
  background-size: auto 100%;
  margin-bottom: 10px;
}

.stats-title {
  position: absolute;
  top: 0;
  left: 38px;
  font-family: YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 19px;
  color: #FFFFFF;
  line-height: 12px;
}

.more-link {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.more-link:hover {
  // 显示下划线
  text-decoration: underline;
}

.equipment-stats {
  display: flex;
  justify-content: center;
  width: 100%;
  flex: 1;
}

.stat-card {
  background-image: url(../../../../static/image/six/equipment-bg1.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  border-radius: 4px;
}

.stat-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.section-label {
  width: 50%;
  font-size: 14px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.status-icon {
  width: 22px;
  height: 22px;
  vertical-align: middle;
  // 放大图标
  transform: scale(2);
}

.section-value {
  width: 50%;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
